import script from "./UserVipList.vue?vue&type=script&setup=true&lang=js"
export * from "./UserVipList.vue?vue&type=script&setup=true&lang=js"

import "./UserVipList.vue?vue&type=style&index=0&id=4324ce12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4324ce12"]])

export default __exports__